// Shared constants for categories, units, districts.

export const CATEGORIES = [
  { key: "produce", ne: "उत्पादन", en: "Produce" },
  { key: "livestock", ne: "पशुपालन", en: "Livestock" },
];

export const UNITS = [
  { key: "किलो", ne: "किलो", en: "kg" },
  { key: "क्विन्टल", ne: "क्विन्टल", en: "Quintal" },
  { key: "टन", ne: "टन", en: "Ton" },
  { key: "लिटर", ne: "लिटर", en: "Litre" },
  { key: "दर्जन", ne: "दर्जन", en: "Dozen" },
  { key: "वटा", ne: "वटा", en: "Piece" },
  { key: "बोरा", ne: "बोरा", en: "Sack" },
  { key: "अन्य", ne: "अन्य", en: "Other" },
];

export const DISTRICTS = [
  "काठमाडौं",
  "ललितपुर",
  "भक्तपुर",
  "कास्की",
  "चितवन",
  "मोरङ",
  "सुनसरी",
  "झापा",
  "इलाम",
  "धनकुटा",
  "पर्सा",
  "बारा",
  "रौतहट",
  "सिरहा",
  "सप्तरी",
  "मकवानपुर",
  "नुवाकोट",
  "धादिङ",
  "गोरखा",
  "लमजुङ",
  "तनहुँ",
  "स्याङ्जा",
  "पाल्पा",
  "रुपन्देही",
  "कपिलवस्तु",
  "दाङ",
  "बाँके",
  "बर्दिया",
  "सुर्खेत",
  "कैलाली",
  "कञ्चनपुर",
  "डोटी",
  "बाजुरा",
  "जुम्ला",
  "मुस्ताङ",
  "मनाङ",
  "सोलुखुम्बु",
  "ओखलढुंगा",
  "उदयपुर",
  "दोलखा",
  "सिन्धुपाल्चोक",
  "काभ्रे",
];

export const categoryLabel = (key, lang) => {
  const c = CATEGORIES.find((x) => x.key === key);
  return c ? c[lang] : key;
};

export const unitLabel = (key, lang) => {
  const u = UNITS.find((x) => x.key === key);
  return u ? u[lang] : key;
};

// Convert western digits to Devanagari for Nepali display.
const NE_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
export const toNeDigits = (val, lang) => {
  const s = String(val);
  if (lang !== "ne") return s;
  return s.replace(/[0-9]/g, (d) => NE_DIGITS[+d]);
};

// Convert Devanagari (and Arabic-Indic) digits back to Western, then parse.
export const toWesternDigits = (val) =>
  String(val ?? "").replace(/[०-९]/g, (d) => "०१२३४५६७८९".indexOf(d));

export const parseNum = (val) => {
  const n = parseFloat(toWesternDigits(val).replace(/[^0-9.]/g, ""));
  return Number.isNaN(n) ? 0 : n;
};

export const formatPrice = (price, lang) => {
  const n = Number(price).toLocaleString("en-IN");
  return toNeDigits(n, lang);
};

export const CONTACT = {
  email: "info@nepalimandi.com",
  phone: "",
};
